import { Redirect } from 'expo-router';

export default function CreateTabRoute() {
  return <Redirect href="/home" />;
}
